export default "__VITE_ASSET__Bh08iB1f__"